var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"secMusic"}},[_c('h2',{attrs:{"id":"hMusic"}},[_vm._v(_vm._s(_vm.$t("headers.music")))]),_c('div',{staticClass:"readFriendlyLayout",attrs:{"id":"digitalDistributionStreaming"}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("view.music.streaming-text"))+" ")]),_c('IconLinks',{attrs:{"iconLinks":_vm.digitalStreamingVendors}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }